import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';

import SharedIconButton from './buttons/shared-icon-button';

export interface SharedProfileInformationItemActionsProps {
  index: number;
  totalCount: number;
  disabled?: boolean;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
  editTooltipLabel?: string;
  children?: ReactNode;
}

export default function SharedProfileInformationItemActions({
  index,
  totalCount,
  disabled = false,
  onMoveUp,
  onMoveDown,
  onDelete,
  onEdit,
  editTooltipLabel = 'Edit',
  children,
}: SharedProfileInformationItemActionsProps) {
  return (
    <Stack flexDirection="row" gap={2} alignItems="center">
      {children}
      {onMoveDown && (
        <SharedIconButton
          variant="downward"
          tooltipLabel="Move Down"
          component="span"
          disabled={index === totalCount - 1 || disabled}
          size="small"
          onClick={onMoveDown}
        />
      )}
      {onMoveUp && (
        <SharedIconButton
          variant="upward"
          tooltipLabel="Move Up"
          component="span"
          disabled={index === 0 || disabled}
          size="small"
          onClick={onMoveUp}
        />
      )}
      {onEdit && (
        <SharedIconButton
          variant="edit"
          tooltipLabel={editTooltipLabel}
          component="span"
          size="small"
          disabled={disabled}
          onClick={onEdit}
        />
      )}
      {onDelete && (
        <SharedIconButton
          variant="delete"
          tooltipLabel="Delete"
          component="span"
          size="small"
          disabled={disabled}
          onClick={onDelete}
        />
      )}
    </Stack>
  );
}
